import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/colors/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listColors, updateColor } from "../../../redux/actions/table/superadmin/colors";
import EditColorForm from "../../../forms/superadmin/colors/EditColorForm";
import { listLocalization } from "../../../redux/actions/localization";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateColor(formData.id, _.omit(formData, ['id'])).then(() => {
                listColors();

                this.props.readAction(formData.id);

                listLocalization();

                setNotification(__('space-allocation-beta.building-types.flyout.properties.properties-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditColorForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'hex', 'raw_colors']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
